import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/a-happy-couple-smiling-at-eachother.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='brokerage-accounts-services-financial-planning-1'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      disableBottomPadding={false}
      reverseContent={false}
      // content
      subHeadingText={<>How to open a <WidowBlock>brokerage account</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            To open a brokerage account, you&#39;ll need to connect with one of our financial advisors who can walk you through the process, including signing an Account Agreement and other necessary forms. Once you&#39;ve wrapped up the paperwork and deposited money into your account, your advisor will figure out the investments that can align to your goals and will carry out the transactions on your behalf.
          </Typography>
          <Link
            id='brokerage-accounts-services-financial-planning-section-connect-with-an-advisor-link'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/find-a-financial-advisor/'
            ariaLabel='Get started with a Northwestern Mutual Financial Advisor'>
            Connect with an advisor
          </Link>
        </>
      )}
      // image props
      imageAltText='A happy couple sitting outside'
      imageSrcDefault={financialPlanningImageWebp.toString()}
    />
  );
};
